import React, {Component} from 'react';

import {Form, ErrorContainer} from 'form';
import {Link} from 'components/ReactRouterDomLocalized';

import {recoverPassword} from 'backend-helpers/passwordRecover';

import {t} from 'l10n';

export default class ModalMenuForgotPasswordForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            processing: false,
            done: false
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formData, setErrors) {
        if (this.state.processing) return false;

        recoverPassword(formData)
            .then(() => {
                this.setState({
                    done: true,
                    processing: false
                });
            })
            .catch((error) => {
                setErrors(error.messages || error.message, true);
                this.setState({processing: false})
            });

        this.setState({processing: true})
    }

    render() {
        return (
            <div>
                <p className="name">
                    <span>{t('Receive password')}</span>
                    <Link to="/?login" className="header-button">{t('Log in')}</Link>
                </p>
                {!this.state.done ?

                    <Form onSubmit={this.onSubmit}>
                        <ErrorContainer data-errorcontainer={true} allowHtml />

                        <div className="space-between">
                            <div>
                                <input name="email" placeholder="Email" type="email"/>
                            </div>
                        </div>
                        <div className="space-between">
                            <button type='submit' className={!this.state.processing ? 'btn-submit' : 'btn-submit loading'}>{t('Send')}</button>
                        </div>
                        <div>
                            <p className="help-text">{t('Enter your email address or nick to receive your password immediately.')}</p>
                        </div>
                    </Form>

                    :

                    <p className="help-text">{t('Message with the password reset instructions has been sent to your email.')}</p>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/ModalMenu/ModalMenuForgotPasswordForm.js